// extracted by mini-css-extract-plugin
export default {"chart_wrap":"AgeGraph_chart_wrap__kaZAD","chart_header":"AgeGraph_chart_header__Z914O","label":"AgeGraph_label__cc+lo","chart_footer":"AgeGraph_chart_footer__0uLeF"};